import React from 'react'
import MobileHomePage from './Mobile/MobileHomePage'
import ComputerHomePage from './Computer/ComputerHomePage'
import TabletHomePage from './Tablet/TabletHomePage'
import { screenSize } from '../../Common/Common'
import { Button } from 'antd'

const news = (<>
  <div style={{ backgroundColor: '#fff', borderRadius: '30px 30px 30px 30px', padding: '1em 0' }}>
    <div className="contentPadding" style={{ maxWidth: '1200px', margin: '2.5em 0' }}>
      <div style={{ fontSize: '18px' }}>
        <p>La Box Médicale lutte contre le renoncement aux soins particulièrement dans les déserts médicaux. Participez au changement en venant visiter nos Box Médicales, ouvertes 7 jours sur 7.</p>
        <p>Vous représentez une collectivité ? Aidez votre population en lui donnant accès aux médecins généralistes et aux spécialistes au plus vite et au plus proche.</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
          <Button type="primary" size="large" block href="https://laboxmedicale.fr/journees-portes-ouvertes/" style={{ whiteSpace: 'normal', height: 'auto', padding: '8px 15px' }}>Journées Portes Ouvertes - Inscrivez-vous gratuitement</Button>
          <Button type="primary" size="large" block href="https://laboxmedicale.fr">On parle de nous</Button>
        </div>
      </div>
    </div>
  </div>
</>)

const cssMaterial = {
  fontSize: '25px',
  fontWeight: 'bold',
  borderWidth: '2px',
  borderColor: 'rgb(240, 240, 240)',
  borderStyle: 'solid',
  borderRadius: '25px',
  padding: '0.5em 60px'
}

const cssNumber = {
  color: '#ff4438',
  fontWeight: 'bold',
  display: 'inline-block',
  width: '1.5em'
}

const css = {
  cssMaterial,
  cssNumber
}

export default function HomePage () {
  const layouts = {
    Mobile: MobileHomePage,
    Computer: ComputerHomePage,
    Tablet: TabletHomePage
  }

  const ResponsiveLayout = layouts[screenSize()]

  return (
    <ResponsiveLayout news={news} css={css} />
  )
}
